import { render, staticRenderFns } from "./BlockoutDaysDeleteButton.vue?vue&type=template&id=96598332&"
import script from "./BlockoutDaysDeleteButton.vue?vue&type=script&lang=js&"
export * from "./BlockoutDaysDeleteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96598332')) {
      api.createRecord('96598332', component.options)
    } else {
      api.reload('96598332', component.options)
    }
    module.hot.accept("./BlockoutDaysDeleteButton.vue?vue&type=template&id=96598332&", function () {
      api.rerender('96598332', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamMembers/components/BlockoutDaysDeleteButton.vue"
export default component.exports